import { render, staticRenderFns } from "./returnRecord.vue?vue&type=template&id=d61c9158&scoped=true&"
import script from "./returnRecord.vue?vue&type=script&lang=js&"
export * from "./returnRecord.vue?vue&type=script&lang=js&"
import style0 from "./returnRecord.vue?vue&type=style&index=0&id=d61c9158&prod&lang=scss&scoped=true&"
import style1 from "./returnRecord.vue?vue&type=style&index=1&id=d61c9158&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d61c9158",
  null
  
)

export default component.exports